import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { util } from '../util';
import * as _ from 'underscore';
import { IObject } from '../../../type_definitions/datatypes';
import { catchError, map } from 'rxjs/operators';
import { HttpEtagService } from './http-etag.service';

@Injectable()
export class HttpEtagInterceptor implements HttpInterceptor {

  constructor(
    private httpEtagService:HttpEtagService
  ) {
    /**/
  }

  public intercept(req:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>> {
    const headers:IObject = {};

    if (_.indexOf(this.httpEtagService.allowedMethods, req.method) > -1) {
      const eTag:string = this.httpEtagService.getETag(req.url);
      if (!req.headers.get('If-Match') && util.notNullOrUndefined(eTag) && !req.headers.has('noIfMatch')) {
        //add an If-Match Header
        headers[ 'If-Match' ] = eTag;
      } else {
        req.headers.delete('If-Match');
      }
    }

    return next.handle(req.clone({ setHeaders: headers }))
      .pipe(
        map((event:HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const newETag:string = event.headers.get('ETag');

            if (util.notNullOrUndefined(newETag)) {
              const currentETag:string = this.httpEtagService.getETag(req.url);
              this.httpEtagService.addETag(req.url, newETag);
              if (util.notNullOrUndefined(currentETag) && currentETag !== newETag) {
                return event.clone({
                  body: _.extend(event.body || {}, { eTagChanged: true })
                });
              }
            }
          }
          return event;
        }),
        catchError((event:HttpErrorResponse) => {
          const newETag:string = event.headers.get('ETag');
          const error:IObject = _.clone(event.error || {});

          if (util.notNullOrUndefined(newETag)) {
            const currentETag:string = this.httpEtagService.getETag(req.url);
            if (util.notNullOrUndefined(currentETag) && currentETag !== newETag) {
              error.eTagChanged = true;
            }
            this.httpEtagService.addETag(req.url, newETag);
          }

          throw new HttpErrorResponse({ ...event, error });
        })
      );
  }
}